export const POPUPS_ALERT_CONFIRM_NAME = 'popups.alert.confirm';
export const POPUPS_ALERT_OK_NAME = 'popups.alert.ok';
export const POPUPS_ALERT_LANG_DETECTION_NAME = 'popups.alert.lang.detection';
export const POPUPS_ALERT_CUSTOM_NAME = 'popups.alert.custom';
